<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit"> 区块链运维监控平台</p>
      <p class="txt">实时监测区块链服务运行性能</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/product/part1-bg.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">产品介绍</p>
      <div class="line">
        恒为区块链运维监控平台实时监控整个区块链网络，通过可视化的方式向区块链运维人员展示了区块链节点服务器的资源状态和区块链网络的运行状态，通过异常报警机制辅助运维人员管理区块链节点，减轻了大量节点运维带来的工作量。
      </div>

    </div>


    <div class="part4">
      <p class="tit">产品特性及优势</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/operation/part4-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">可视化监控</p>
            <p class="text">
              节点服务器资源水位和节点网络运行状态可视化监控
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/operation/part4-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">风险分析</p>
            <p class="text">
              根据节点服务器资源和区块链网络情况分析潜在的运行风险
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/operation/part4-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">异常报警</p>
            <p class="text">
              异常报警提醒，及时通知区块链节点运维人员运维检查
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="part5">
      <p class="tit">产品核心功能</p>
      <div class="content">
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/operation/part5-1.png"
              alt=""
            >
          </div>
          <p>节点监控 </p>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/operation/part5-2.png"
              alt=""
            >
          </div>
          <p>节点管理 </p>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/operation/part5-3.png"
              alt=""
            >
          </div>
          <p>账户管理 </p>
        </div>

        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/operation/part5-4.png"
              alt=""
            >
          </div>
          <p>通知提醒 </p>
        </div>

      </div>

    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  background: linear-gradient(-30deg, #192F9C, #1185E9);
  position: relative;
  part1();
  padding-top: vw(60);

  .tit {
    margin-bottom: vw(25);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(50);
    text-align: center;

    img {
      width: vw(314);
      height: vw(350);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .line {
    font-size: vw(28);
    color: #666666;
    line-height: vw(48);
    margin-bottom: vw(30);
    padding: 0 vw(30);
  }
}

.part3 {
  part();
  padding: vw(80) 0 vw(100);
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .img {
    text-align: center;

    img {
      width: vw(690);
      height: vw(364);
    }
  }
}

.part4 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(231);
      margin: 0 auto vw(30);
      padding: vw(58) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
        }
      }
    }
  }
}

.part5 {
  part();
  background: #fff;
  padding: vw(80) vw(17) vw(50);

  .tit {
    tit3();
    margin-bottom: vw(50);
  }

  .content {
    display: flex;
    flex-wrap: wrap;

    .card {
      width: vw(170);
      height: vw(170);
      margin: 0 vw(33) vw(30);
      border-radius: vw(10);
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .img {
        text-align: center;
        margin: vw(37) 0 vw(20px);

        img {
          width: vw(50);
          height: vw(50);
        }
      }

      p {
        font-size: vw(24);
        color: #444444;
        text-align: center;
        line-height: vw(24);
      }
    }
  }
}
</style>
